//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MediaTrackingQueue } from '@tracker/mediaTracking/mediaTrackingEventQueue';
import {
  MediaTrackingEventComponentLevelData,
  MediaTrackingSource,
} from '@tracker/mediaTracking/mediaTrackingModel';

export interface IEventTrackingHandler {
  track: (event: MediaTrackingEventComponentLevelData) => void;
  dispatchImmediately: (event?: MediaTrackingEventComponentLevelData) => void;
}

export const getMediaTrackingHandler = (
  source: MediaTrackingSource,
): IEventTrackingHandler => {
  const eventQueue = MediaTrackingQueue;
  const dispatchImmediately = () => {
    eventQueue.dispatchEvents();
  };

  const track = (event: MediaTrackingEventComponentLevelData) => {
    if (source !== MediaTrackingSource.NO_SOURCE) {
      eventQueue.push({
        ...event,
        source: source,
        timestamp: Date.now(),
      });
    } else {
      eventQueue.debug('No source provided, not tracking event', event);
    }
  };

  return {
    track,
    dispatchImmediately,
  };
};
